export default {
  list: {
    breadcrumb: {
      home: 'Trang chủ',
      formPage: 'List',
      basicList: 'Basic List',
      cardList: 'Card List',
      editableList: 'Editable List',
      advanceList: 'Advance List',
      treeList: 'Tree List',
    },
    basicList: {
      title: 'Basic List',
      description: 'Allows users to adjust the list size and spacing.'
    },
    cardList: {
      title: 'Card List',
      description: 'Information can be displayed in card format and the search function is supported.'
    },
    editableList: {
      title: 'Editable List',
      description: 'Supports table extension and table editing.'
    },
    advanceList: {
      title: 'Advance List',
      description: 'Allows users to select multiple items in the list and delete them in batches. Allows users to adjust the column width by dragging and dragging. Supports virtual scrolling, lazy loading, and filtering.'
    },
    treeList: {
      title: 'Tree List',
      description: 'Tree table rendering is supported.'
    }
  },
};
